import { render, staticRenderFns } from "./VerticalAdd.vue?vue&type=template&id=8c492572&scoped=true"
import script from "./VerticalAdd.vue?vue&type=script&lang=js"
export * from "./VerticalAdd.vue?vue&type=script&lang=js"
import style0 from "./VerticalAdd.vue?vue&type=style&index=0&id=8c492572&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c492572",
  null
  
)

export default component.exports